module.exports = __webpack_public_path__ + "img/title-long.5dad17be.png";